const REPLY_SORTING_OPTIONS: { [key: string]: string } = {
  oldestFirst: 'Oldest first',
  mostRecentFirst: 'Newest first',
  mostLiked: 'Most liked'
}

export {
  REPLY_SORTING_OPTIONS
}
